module.exports = __webpack_public_path__ + "static/media/shipsyLogo.6284d9d4.svg";